// extracted by mini-css-extract-plugin
export default {"mv":"Video_mv__KS-Pl","video":"Video_video__8MiAm"};